// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\WidgetBookingBillingOptionsResponse

import { hydrateWidgetBookingBillingOptionItem, type WidgetBookingBillingOptionItem, type WidgetBookingBillingOptionItemApiResponse } from './widgetBookingBillingOptionItem.gen';
import { hydrateWidgetBookingBillingSplitPayment, type WidgetBookingBillingSplitPayment, type WidgetBookingBillingSplitPaymentApiResponse } from './widgetBookingBillingSplitPayment.gen';

export type WidgetBookingBillingOptionsApiResponse = {
	acceptGiftcards: boolean;
	acceptPromoCodes: boolean;
	fullPayment: WidgetBookingBillingOptionItemApiResponse | null;
	deposit: WidgetBookingBillingOptionItemApiResponse | null;
	guarantee: WidgetBookingBillingOptionItemApiResponse | null;
	damageGuarantee: WidgetBookingBillingOptionItemApiResponse | null;
	payOnsite: WidgetBookingBillingOptionItemApiResponse | null;
	splitPayment: WidgetBookingBillingSplitPaymentApiResponse | null;
};

export type WidgetBookingBillingOptions = {
	acceptGiftcards: boolean;
	acceptPromoCodes: boolean;
	fullPayment: WidgetBookingBillingOptionItem | null;
	deposit: WidgetBookingBillingOptionItem | null;
	guarantee: WidgetBookingBillingOptionItem | null;
	damageGuarantee: WidgetBookingBillingOptionItem | null;
	payOnsite: WidgetBookingBillingOptionItem | null;
	splitPayment: WidgetBookingBillingSplitPayment | null;
};

export function hydrateWidgetBookingBillingOptions(data: WidgetBookingBillingOptionsApiResponse): WidgetBookingBillingOptions {
	return {
		...data,
		fullPayment: data.fullPayment ? hydrateWidgetBookingBillingOptionItem(data.fullPayment) : null,
		deposit: data.deposit ? hydrateWidgetBookingBillingOptionItem(data.deposit) : null,
		guarantee: data.guarantee ? hydrateWidgetBookingBillingOptionItem(data.guarantee) : null,
		damageGuarantee: data.damageGuarantee ? hydrateWidgetBookingBillingOptionItem(data.damageGuarantee) : null,
		payOnsite: data.payOnsite ? hydrateWidgetBookingBillingOptionItem(data.payOnsite) : null,
		splitPayment: data.splitPayment ? hydrateWidgetBookingBillingSplitPayment(data.splitPayment) : null,
	};
}